const formFields = [
  {
    name: "name",
    label: "نام ",
    type: "text",
    placeholder: " لطفا نام را وارد کنید",
    colSpan: 6, // اضافه کردن prop جدید برای کنترل عرض
  },
  {
    name: "last_name",
    label: "نام خانوادگی",
    type: "text",
    placeholder: " نام خانوادگی  را وارد کنید",
    colSpan: 6,
  },
  {
    name: "national_code",
    label: "کد ملی ",
    type: "text",
    placeholder: "کد ملی  را وارد کنید",
    colSpan: 6,
  },
  {
    name: "phone_number",
    label: "شماره همراه",
    type: "text",
    placeholder: "شماره همراه را وارد کنید",
    colSpan: 6,
  },

  {
    name: "capacity_ton",
    label: "ظرفیت(تن)",
    type: "text",
    placeholder: " ظرفیت  را وارد کنید",
    colSpan: 6,
  },
];
export const persianLetters = [
  "الف",
  "ب",
  "پ",
  "ت",
  "ث",
  "ج",
  "چ",
  "ح",
  "خ",
  "د",
  "ذ",
  "ر",
  "ز",
  "ژ",
  "س",
  "ش",
  "ص",
  "ض",
  "ط",
  "ظ",
  "ع",
  "غ",
  "ف",
  "ق",
  "ک",
  "گ",
  "ل",
  "م",
  "ن",
  "و",
  "ه",
  "ی",
];
export default formFields